import { render, staticRenderFns } from "./WebPagesCoworkersBlockForm.vue?vue&type=template&id=1738246e&"
import script from "./WebPagesCoworkersBlockForm.vue?vue&type=script&lang=js&"
export * from "./WebPagesCoworkersBlockForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports